var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhsArrival(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1746500738625,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 23165,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M684.75091 784.3c11.7-103 104.4-177 207.2-165.2 7.7 0.8 15.5 2.3 23 4V509.9h51.9c11.5 0 20.9-9.4 20.9-21 0-5.7-2.3-11.1-6.3-15.1L537.85091 38.1c-24.5-23.9-63.4-23.9-87.9 0L6.25091 473.8C-1.94909 482-2.14909 495.2 6.05091 503.4c4 4 9.4 6.3 14.9 6.3h56.5V929c0 34.6 28.3 62.9 62.8 62.9h709.5c-102.8-11.7-176.7-104.6-165-207.6zM475.25091 522.4H274.35091c-11.5 0-20.9-9.4-20.9-21v-97.9c0-11.5 9.4-21 20.9-21h200.9v139.9z m41.9-139.8H718.05091c11.5 0 20.9 9.4 20.9 21v97.9c0 11.5-9.4 21-20.9 21H517.15091V382.6z m465 382h-123l18.4-18.5c16.3-16.4 16.3-43 0-59.3-16.3-16.4-42.9-16.4-59.2 0l-88.1 88.1c-16.3 17.2-16.3 44 0 61.2l88.1 88.1c16.3 16.4 42.9 16.4 59.2 0 16.3-16.4 16.3-43 0-59.3L861.05091 848.3h121.2c23 0 41.9-18.9 41.9-41.9-0.1-23.1-19-41.8-42-41.8z",
    fill: "#ffffff",
    "p-id": 23166
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsArrival);
export default __webpack_public_path__ + "static/media/whsArrival.0616efdec7e14274ba373ab5d868d223.svg";
export { ForwardRef as ReactComponent };